module.exports = __webpack_public_path__ + "themes/non-default/privateAssetLabSlideoutAsset.26a96b15044cc3b77cbe7fe372e61db3.png";